var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style['al-form-group']},[_vm._t("default"),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],class:_vm.$style['al-form-group-error']},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }